import React, {FC} from 'react';
import {cx} from './cx';

export type IconName =
  | 'arrow-right'
  | 'check'
  | 'chevron-down'
  | 'close'
  | 'external'
  | 'gift'
  | 'heart'
  | 'link'
  | 'menu'
  | 'minus'
  | 'plus'
  | 'share'
  | 'sparkle'
  | 'users';

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
  label?: string;
}

const paths: Record<IconName, React.ReactNode> = {
  'arrow-right': (
    <>
      <path d="M5 12h14" />
      <path d="m13 6 6 6-6 6" />
    </>
  ),
  check: <path d="m5 12 4 4L19 6" />,
  'chevron-down': <path d="m6 9 6 6 6-6" />,
  close: (
    <>
      <path d="m6 6 12 12" />
      <path d="M18 6 6 18" />
    </>
  ),
  external: (
    <>
      <path d="M14 5h5v5" />
      <path d="m10 14 9-9" />
      <path d="M19 13v6H5V5h6" />
    </>
  ),
  gift: (
    <>
      <path d="M4 10h16v10H4z" />
      <path d="M2.5 6.5h19v4h-19z" />
      <path d="M12 6.5V20" />
      <path d="M12 6.5C9 6.5 7 5.4 7 3.8c0-1 .8-1.8 1.9-1.8C10.7 2 12 4.1 12 6.5Z" />
      <path d="M12 6.5c3 0 5-1.1 5-2.7 0-1-.8-1.8-1.9-1.8C13.3 2 12 4.1 12 6.5Z" />
    </>
  ),
  heart: (
    <path d="M20.8 5.7a5.4 5.4 0 0 0-7.7 0L12 6.8l-1.1-1.1a5.4 5.4 0 0 0-7.7 7.7L12 22l8.8-8.6a5.4 5.4 0 0 0 0-7.7Z" />
  ),
  link: (
    <>
      <path d="M10 13a5 5 0 0 0 7.1.1l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1" />
      <path d="M14 11a5 5 0 0 0-7.1-.1l-2 2A5 5 0 0 0 12 20l1.1-1.1" />
    </>
  ),
  menu: (
    <>
      <path d="M4 7h16" />
      <path d="M4 12h16" />
      <path d="M4 17h16" />
    </>
  ),
  minus: <path d="M5 12h14" />,
  plus: (
    <>
      <path d="M12 5v14" />
      <path d="M5 12h14" />
    </>
  ),
  share: (
    <>
      <circle cx="18" cy="5" r="2.5" />
      <circle cx="6" cy="12" r="2.5" />
      <circle cx="18" cy="19" r="2.5" />
      <path d="m8.2 10.8 7.6-4.5" />
      <path d="m8.2 13.2 7.6 4.5" />
    </>
  ),
  sparkle: (
    <>
      <path d="M12 2c.7 5.5 2.5 7.3 8 8-5.5.7-7.3 2.5-8 8-.7-5.5-2.5-7.3-8-8 5.5-.7 7.3-2.5 8-8Z" />
      <path d="M19 16c.3 2.1.9 2.7 3 3-2.1.3-2.7.9-3 3-.3-2.1-.9-2.7-3-3 2.1-.3 2.7-.9 3-3Z" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3.5 20v-2.2A5.5 5.5 0 0 1 9 12.3a5.5 5.5 0 0 1 5.5 5.5V20" />
      <path d="M15 5.2a3.2 3.2 0 0 1 0 5.8" />
      <path d="M17 13.2a5.5 5.5 0 0 1 3.5 5.1V20" />
    </>
  ),
};

export const Icon: FC<IconProps> = ({
  name,
  size = 20,
  className,
  label,
}) => (
  <svg
    aria-hidden={label ? undefined : true}
    aria-label={label}
    className={cx('sui-icon', className)}
    fill="none"
    height={size}
    role={label ? 'img' : undefined}
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.8"
    viewBox="0 0 24 24"
    width={size}
  >
    {paths[name]}
  </svg>
);
